import {useGetTasksForPeep} from '../graphql/hooks/use-get-tasks-for-peep';

export function useGetPeepOpenTasksCount(entityId: string): string | undefined {
    const {tasks} = useGetTasksForPeep(entityId);

    const openTasks = tasks?.filter((task) => !task.isCompleted);

    return openTasks && openTasks.length ? `${openTasks.length}` : undefined;
}
